import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import {buttonType} from '../../../utils/commonPropTypes'
import WidthContainer from '../../../components/WidthContainer'

import membershipIllustration from '../images/membershipIllustration.svg'
import Blob from '../../../components/Blob'
import {QueryedButton} from '../../../components/Button'

const phoneBreakpoint = '@media only screen and (max-width: 1000px)'

const RootContainer = styled(WidthContainer)`
	position: relative;
	margin-top: 6rem;
	
	.onlyPhone {
		display: none;
	}
	
	${phoneBreakpoint} {
		.onlyPhone {
			display: block;
		}
		.onlyBig {
			display: none;
		}
	}
`

const Inner = styled.div`
	display: flex;
	margin: -1.8rem;
	
	
	${phoneBreakpoint} {
		margin-top: -5.8rem;
		margin-bottom: -7rem;
		justify-content: center;
		> * {
			max-width: 25rem;
		}
	}
	>* {
		margin: 1.8rem;
		
	}
`


const Column = styled.div`
	flex: 1;
	
`

const Title = styled.h1`
	margin-top: 2.5rem;
`
const Text = styled.div`
`


const Illustration = styled.img`
	margin-top: -5rem;
	${phoneBreakpoint} {
		margin-top: 0rem;
	}
`
Illustration.defaultProps = {
	src: membershipIllustration,
	alt: '',
}

const BlobOuter = styled.div`
	margin-top: 5.3rem;
`

const BlobStyled = styled(Blob)`
`

const BlobTitle = styled.div`
	font-size: ${props => props.theme.fontSizes.big20};
	font-weight: ${props => props.theme.fontWeights.bold};
	margin-bottom: 1.5rem;
	
	${props => props.type === 1 && `
		margin-bottom: 0;
	`}
	
	${props => props.type === 3 && `
		font-size: ${props.theme.fontSizes.big30};
	`}
`

const BlobText = styled.div`
	font-size: ${props => props.theme.fontSizes.small};
	max-width: 17.4rem;
`

const BlobMeta = styled.div`
	margin-bottom: 2.6rem;
	font-weight: ${props => props.theme.fontWeights.regular};
`

const BlobButton = styled(QueryedButton)`
	margin-top: 1.5rem;
`

const BlobInner = styled.div`
	max-width: 21rem;
`

const Bubble = styled.div`
	width: 6.25rem;
	height: 6.25rem;
	border-radius: 100%;
	background: ${props => props.theme.colors.main};
	color: white;
	position: absolute;
	top: -6rem;
	right: -2rem;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	
	@media only screen and (max-width: 400px) {
		right: 0;
		top: -7rem;
	}
`

const BubbleDiscountNumber = styled.div`
	font-size: ${props => props.theme.fontSizes.big25};
	font-weight: ${props => props.theme.fontWeights.bold};
	margin: 0;
	line-height: 1;
	margin-bottom: .25rem;
	padding-top: .3rem;
`

const BubbleDiscountLabel = styled.div`
	font-size: ${props => props.theme.fontSizes.extraSmall};
	line-height: 1;
	margin: 0;
`

const DiscountBubble = ({className, type, title, meta, text, discount, button, discountLabel}) => <BlobOuter
	className={className}>
	<BlobStyled
		blobType={type + 4}
		minimalWidth>
		<BlobInner type={type}>
			<Bubble>
				<BubbleDiscountNumber>{discount}</BubbleDiscountNumber>
				<BubbleDiscountLabel>{discountLabel}</BubbleDiscountLabel>
			</Bubble>
			<BlobTitle type={type}>{title}</BlobTitle>
			{meta && <BlobMeta>{meta}</BlobMeta>}
			<BlobText>{text}</BlobText>
			{button && <BlobButton data={button}/>}
		</BlobInner>
	</BlobStyled>
</BlobOuter>

DiscountBubble.propTypes = {
	type: PropTypes.oneOf([1, 2, 3]).isRequired,
	title: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
	discount: PropTypes.string.isRequired,
	discountLabel: PropTypes.string.isRequired,
	meta: PropTypes.string,
	button: buttonType,
}

DiscountBubble.defaultProps = {
	meta: null,
	button: null,
}

const MembershipSection = ({className, data}) => <RootContainer className={className}>
	<Inner>
		<Column>
			<Illustration className='onlyPhone'/>
			<Title>{data.title}</Title>
			<Text>{data.text}</Text>
			<DiscountBubble type={1} {...data.perk1} discountLabel={data.discountLabel}/>
			<DiscountBubble className='onlyPhone' type={2} {...data.perk2} discountLabel={data.discountLabel}/>
			<DiscountBubble type={3} {...data.perk3} discountLabel={data.discountLabel}/>
		</Column>
		<Column className='onlyBig'>
			<Illustration/>
			<DiscountBubble type={2} {...data.perk2} discountLabel={data.discountLabel}/>
		</Column>
	</Inner>
</RootContainer>

MembershipSection.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		title: PropTypes.string.isRequired,
		text: PropTypes.string.isRequired,
		discountLabel: PropTypes.string.isRequired,
		perk1: PropTypes.shape({
			title: PropTypes.string.isRequired,
			meta: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
			discount: PropTypes.string.isRequired,
		}).isRequired,
		perk2: PropTypes.shape({
			title: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
			discount: PropTypes.string.isRequired,
		}).isRequired,
		perk3: PropTypes.shape({
			title: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
			button: buttonType.isRequired,
			discount: PropTypes.string.isRequired,
		}).isRequired,

	}).isRequired,
}

MembershipSection.defaultProps = {
	className: '',
}

export default MembershipSection
